/**
 * ExamList
 * ========
 * Grid of exams. Clicking a card selects the exam so its result
 * table can be loaded.
 */

import React from 'react';

const ExamList = ({ exams, onSelect }) => {
  if (!exams.length) {
    return (
      <div className="results-empty">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
        </svg>
        <p>No exams found</p>
      </div>
    );
  }

  return (
    <div className="results-exam-grid">
      {exams.map((exam) => (
        <button
          key={exam.Exam_Id}
          type="button"
          className="results-exam-card"
          onClick={() => onSelect(exam)}
        >
          <div className="results-exam-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
          <div className="results-exam-info">
            <span className="results-exam-name">{exam.Exam_Name || 'Untitled Exam'}</span>
            {exam.Exam_Short_Name && (
              <span className="results-exam-short">{exam.Exam_Short_Name}</span>
            )}
          </div>
          <span className={`results-exam-count ${exam.resultCount ? '' : 'is-zero'}`}>
            {exam.resultCount} result{exam.resultCount !== 1 ? 's' : ''}
          </span>
          <svg className="results-exam-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      ))}
    </div>
  );
};

export default ExamList;
